





































































































































































































































































































































































































import {
  Component,
  Prop,
  Vue,
  Watch,
} from 'vue-property-decorator';
import {Action} from 'vuex-class';
import ConnectivityService from '@/services/connectivity.service';
import {LoRaNetworkServer} from '@/types';
import CancelButton from '@/components/CancelButton.vue';
import ConfirmButton from '@/components/ConfirmButton.vue';

const HOST = {
  IOT_SCOTLAND_OLD: 'boston-iot.net',
  IOT_SCOTLAND: 'north.loriot.io',
  NETMORE: 'api.blink.services',
  LORIOT: 'loriot',
  LORIOT_MANAGED: 'loriot_managed',
  THINGPARK: 'actility-thingpark',
  TTI: 'theThingsIndustry',
  TTN: 'theThingsNetwork',
};

@Component({
  components: {CancelButton, ConfirmButton},
})
export default class LoRaWANServerForm extends Vue {
  @Action private addToastErrorMessage: any;

  @Prop({default: null}) private config!: any;
  @Prop({default: () => []}) private servers!: LoRaNetworkServer[];
  @Prop({default: () => []}) private takenHosts!: string[];

  private get items() {
    return this.servers
        .filter((s: any) => s.display === true)
        .map((s: any) => ({ text: s.name, val: s.host }));
  }

  private get server(): LoRaNetworkServer | undefined {
    if (this.config) {
      return this.servers.find((s: any) => s.host === this.config.lns);
    }
    const item = this.items.find((i) => i.text === this.lns);
    return item ? this.servers.find((s: any) => s.host === item.val) : undefined;
  }

  private get applicationServer() {
    return this.tenant && this.tenant.length ? `${this.tenant}.${this.applicationServerUrl}` : this.applicationServerUrl;
  }

  private get requiredRules() {
    return {
      username: [
        (v: string) => !!v || `Username can't be empty`,
      ],
      password: [
        (v: string) => !!v || `Password can't be empty`,
      ],
      customerId: [
        (v: string) => !!v || `Customer ID can't be empty`,
        (v: string) => !isNaN(Number(v)) || `Customer ID must be a number`,
      ],
      clientSecret: [
        (v: string) => !!v || `Client Secret can't be empty`,
      ],
      clientId: [
        (v: string) => !!v || `Client ID can't be empty`,
      ],
      clusterId: [
        (v: string) => (!v || (v && !isNaN(Number(v)))) || `Cluster ID must be a number`,
      ],
      applicationServer: [
        (v: string) => !!v || `Application server can't be empty `,
      ],
      cluster: [
        (v: string) => !!v || `Must select a cluster`,
      ],
      apiKey: [
        (v: string) => !!v || `API key can't be empty`,
      ],
      organisationId: [
        (v: string) => !!v || `Organisation ID can't be empty`,
      ],
      tenant: [
        (v: string) => !!v || `Tenant ID can't be empty`,
      ],
      serviceProviderCode: [
        (v: string) => !!v || `Service provider code can't be empty`,
      ],
      host: [
        (v: string) => !!v || `Network server can't be empty`,
      ],
    };
  }

  private lns: string = '';
  private id: number = 0;
  private host: string = '';

  private isIotScotland: boolean = false;
  private isKerlinkWanesyThirdParty: boolean = false;
  private isTTSThirdParty: boolean = false;
  private isNetmore: boolean = false;
  private isThingPark: boolean = false;
  private isLoriotManaged: boolean = false;
  private username: string = '';
  private password: string = '';
  private applicationId: string = '';
  private organisationId: string = '';
  private applicationServerUrl: string = '';
  private tenant: string = '';
  private apiKey: string = '';
  private serviceProviderCode: string = '';
  private valid: boolean = false;
  private createWebhook: boolean = true;
  private customerId: string = '';
  private clusterId: string = '';
  // thingpark
  private clientSecret: string = '';
  private clientId: string = '';
  private domain: string = '';

  private initialising: boolean = true;
  private saving: boolean = false;
  private hideKey: boolean = true;

  private name: string = '';
  private nameRules = [
    (v: string) => !v || v.trim().length <= 100 || 'Name must be 100 characters or fewer',
  ];

  private LoriotUrls: string[] = [
    'eu4pro.loriot.io',
    'eu1.loriot.io',
    'eu2.loriot.io',
    'eu3.loriot.io',
    'eu5pro.loriot.io',
    'uk1.loriot.io',
    'af1.loriot.io',
    'me1pro.loriot.io',
    'ap1.loriot.io',
    'ap2.loriot.io',
    'ap3.loriot.io',
    'ap4pro.loriot.io',
    'au1.loriot.io',
    'au2pro.loriot.io',
    'il1.loriot.io',
    'us1.loriot.io',
    'us2.loriot.io',
    'us3pro.loriot.io',
    'sa1.loriot.io',
    'sa2pro.loriot.io',
  ];
  private TTNUrls: string[] = [
    'eu1.cloud.thethings.network',
    'nam1.cloud.thethings.network',
    'au1.cloud.thethings.network',
  ];
  private TTIUrls: string[] = [
    'eu1.cloud.thethings.industries',
    'eu2.cloud.thethings.industries',
    'nam1.cloud.thethings.industries',
    'au1.cloud.thethings.industries',
  ];
  private thingsStackCloudEnabled = true;
  private privateLoriotServerEnabled = false;

  @Watch('lns')
  public onLnsChanged() {
    const lns = this.lns.toLowerCase();
    if (!this.initialising) {
      this.host = '';
    }
    this.createWebhook = true;

    this.isKerlinkWanesyThirdParty = false;
    this.isTTSThirdParty = false;
    this.isNetmore = false;
    this.isLoriotManaged = false;
    this.isIotScotland = false;
    this.isThingPark = false;
    if (lns === 'alliot wanesy') {
      this.isKerlinkWanesyThirdParty = true;
      this.host = 'alliot.wanesy.com';
    } else if (lns === 'the things industries' || lns === 'the things network') {
      this.isTTSThirdParty = true;
    } else if (lns === 'netmore') {
      this.isNetmore = true;
    } else if (lns === 'loriot' || lns === 'iot scotland') {
      this.isLoriotManaged = true;
      if (lns === 'iot scotland') {
        this.isIotScotland = true;
        this.host = 'north.loriot.io';
      }
    } else if (lns === 'actility thingpark') {
      this.isThingPark = true;
    }
  }

  private get missingRequired(): boolean {
    if (this.isKerlinkWanesyThirdParty) {
      return !this.username || !this.password || !this.customerId || !this.clusterId;
    }
    if (this.isTTSThirdParty) {
      return !this.tenant || !this.apiKey || !this.organisationId || !this.applicationServerUrl;
    }
    if (this.isNetmore) {
      return !this.username || !this.password || !this.serviceProviderCode;
    }
    if (this.isLoriotManaged) {
      return !this.host || !this.apiKey;
    }
    if (this.isThingPark) {
      return !this.host || !this.clientId || !this.clientSecret;
    }
    return false;
  }

  private get isEditableExisting(): boolean {
    const server: any = this.server;
    return !!this.id && !!server && [HOST.IOT_SCOTLAND_OLD, HOST.TTI, HOST.TTN].includes(server.host);
  }

  private get canSave(): boolean {
    if (this.saving || !this.server) {
      return false;
    }
    if (this.id && !this.isEditableExisting) {
      return false;
    }
    return !this.missingRequired;
  }

  private toggleTTISwitch() {
    if (!this.id && this.applicationServerUrl.endsWith('cloud.thethings.industries')) {
      this.thingsStackCloudEnabled = false;
    } else if (!!this.id && !this.applicationServerUrl.endsWith('cloud.thethings.industries')) {
      this.thingsStackCloudEnabled = false;
    } else {
      this.thingsStackCloudEnabled = true;
    }
  }

  private toggleLoriotSwitch() {
    if (!this.isLoriotManaged) {
      return;
    }
    const isPublicServer = this.LoriotUrls.includes(this.host);

    if (this.id) {
      this.privateLoriotServerEnabled = !isPublicServer;
    } else if (!this.privateLoriotServerEnabled) {
      this.host = '';
    }
  }

  private async mounted() {
    this.initialising = true;
    try {
      if (this.config) {
        this.populate(this.config);
      }
    } finally {
      await this.$nextTick();
      this.initialising = false;
      this.toggleTTISwitch();
      this.toggleLoriotSwitch();
    }
  }

  private populate(creds: any) {
    const item: any = this.servers.find((l: any) => l.host === creds.lns);
    if (!item) {
      return;
    }
    this.lns = item.name;
    this.id = creds.id;
    if (creds.lns === HOST.IOT_SCOTLAND_OLD || creds.lns === 'alliot.wanesy.com') {
      this.clusterId = creds.clusterId || '';
      this.customerId = creds.customerId || '';
      this.username = creds.username || '';
      this.password = creds.password || '';
      this.host = creds.lns;
    } else if (creds.lns === HOST.TTI || creds.lns === HOST.TTN) {
      const tenantIndex = creds.application_server!.indexOf('.') + 1;
      this.applicationServerUrl = creds.lns === HOST.TTI ? creds.application_server!.substring(tenantIndex) : creds.application_server || '';
      this.applicationId = creds.application_id || '';
      this.organisationId = creds.organisation_id || '';
      this.apiKey = creds.api_key || '';
      this.tenant = creds.application_server!.split('.')[0] || '';
    } else if (creds.lns === HOST.NETMORE) {
      this.serviceProviderCode = creds.service_provider_code || '';
      this.username = creds.username || '';
      this.password = creds.password || '';
    } else if (creds.lns === HOST.LORIOT_MANAGED || creds.lns === HOST.LORIOT) {
      this.host = creds.host || '';
      this.apiKey = creds.account_token || creds.api_key || '';
      this.applicationId = creds.application_id || '';
    } else if (creds.lns === HOST.THINGPARK) {
      this.host = creds.network_server || '';
      this.clientId = creds.client_id || '';
      this.clientSecret = creds.client_secret || '';
      this.domain = creds.domain || '';
    }
  }

  private async save() {
    await this.$nextTick();

    const form = this.$refs.form as Vue & { validate: () => boolean };
    const server: any = this.server;
    if (!form || !server || !form.validate()) {
      return;
    }

    const host: string = server.host;
    this.saving = true;
    try {
      let response: any;
      const name = this.name.trim() || undefined;

      if (this.id) {
        if (host === HOST.IOT_SCOTLAND_OLD) {
          response = await ConnectivityService.updateLoRaSettings(host, this.id, this.username, this.password);
        } else {
          response = await ConnectivityService.updateTTISettings(host, this.apiKey);
        }
      } else if (host === HOST.IOT_SCOTLAND_OLD) {
        response = await ConnectivityService.createIoTScotlandSettings(host, this.username, this.password, this.customerId, this.clusterId, name);
      } else if (host === HOST.TTI || host === HOST.TTN) {
        response = await ConnectivityService.createLoRaTTSSettings(host, this.applicationServer, this.apiKey, this.organisationId, this.applicationId, this.createWebhook, name);
      } else if (host === HOST.NETMORE) {
        response = await ConnectivityService.createNetmoreSettings({ username: this.username, password: this.password, service_provider_code: this.serviceProviderCode, name });
      } else if (host === HOST.LORIOT_MANAGED || host === HOST.IOT_SCOTLAND) {
        response = await ConnectivityService.createLoriotSettings({ host: this.host, api_key: this.apiKey, application_id: this.applicationId, create_webhook: this.createWebhook, name });
      } else if (host === HOST.THINGPARK) {
        response = await ConnectivityService.createThingParkSettings({ network_server: this.host, client_id: this.clientId, client_secret: this.clientSecret, domain: this.domain, create_webhook: this.createWebhook, name });
      } else {
        response = await ConnectivityService.createLoRaSetting(host, name);
      }

      this.$emit('saved', response);
    } catch (e) {
      this.addToastErrorMessage((e as Error).message);
    } finally {
      this.saving = false;
    }
  }

  private isThirdParty(): boolean {
    const item: any = this.server;
    return !!item && item.thirdParty;
  }
}
